import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { api } from 'src/api';
import { cast, types } from 'mobx-state-tree';
import { createAsync } from 'src/utils/asyncModel';
const getVendorsAsync = createAsync(body => {
  return async function getVendors(options) {
    var _resp$response;
    const resp = await api.Vendors.getVendors(body, options);
    this.setVendors(resp === null || resp === void 0 || (_resp$response = resp.response) === null || _resp$response === void 0 ? void 0 : _resp$response.items);
    return resp;
  };
});
const associateVendorsAsync = createAsync(body => {
  return async function associateVendors(options) {
    const resp = await api.Vendors.associateVendors(body, options);
    return resp;
  };
});
const getVendorsByUtilityProviderIdAsync = createAsync(body => {
  return async function getVendorsByUtilityProviderId(options) {
    const resp = await api.Vendors.getVendorsByUtilityProviderId(body, options);
    this.setVendor(body.utilityProviderId, resp === null || resp === void 0 ? void 0 : resp.response);
    return resp;
  };
});
const Vendor = types.model('Vendor', {
  utilityProviderId: types.maybeNull(types.string),
  externalId: types.maybeNull(types.string),
  appfolioId: types.maybeNull(types.string),
  companyName: types.maybeNull(types.string),
  city: types.maybeNull(types.string),
  line1: types.maybeNull(types.string),
  line2: types.maybeNull(types.string),
  zip: types.maybeNull(types.string),
  state: types.maybeNull(types.string)
});
const TempData = types.model('Vendor', {
  utilityProviderLivableId: types.maybeNull(types.string),
  vendorExternalId: types.maybeNull(types.string)
});
const VendorsStore = types.model('VendorsStore', {
  getVendorsAsync,
  associateVendorsAsync,
  getVendorsByUtilityProviderIdAsync,
  vendors: types.optional(types.array(Vendor), []),
  tempData: types.optional(TempData, {
    utilityProviderLivableId: '',
    vendorExternalId: ''
  })
}).actions(store => ({
  resetStore() {
    store.vendors = cast([]);
    store.tempData = {
      utilityProviderLivableId: '',
      vendorExternalId: ''
    };
  },
  changeTempDataVendor(data) {
    store.tempData.vendorExternalId = data;
  },
  changeTempDataProperty(data) {
    store.tempData.utilityProviderLivableId = data;
  },
  setVendor(utilityProviderId, data) {
    try {
      if (!(data !== null && data !== void 0 && data.externalId)) return;
      const idx = store.vendors.findIndex(i => i.utilityProviderId === utilityProviderId);
      const newObj = _objectSpread({
        utilityProviderId: utilityProviderId
      }, data);
      if (idx > -1) {
        store.vendors.splice(idx, 1);
      }
      store.vendors.push(newObj);
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  setVendors(data) {
    try {
      data.map(item => {
        const idx = store.vendors.findIndex(i => i.externalId === item.externalId);
        if (idx === -1) store.vendors.push(_objectSpread({
          utilityProviderId: null
        }, item));
      });
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  getVendorName(utilityProviderId) {
    const idx = store.vendors.findIndex(i => i.utilityProviderId === utilityProviderId);
    if (idx === -1) return 'N/A';
    return store.vendors[idx].companyName;
  },
  getVendorByUtilityProviderId(utilityProviderId) {
    const idx = store.vendors.findIndex(i => i.utilityProviderId === utilityProviderId);
    if (idx === -1) return null;
    return store.vendors[idx];
  }
}));
export const vendors = types.optional(VendorsStore, {});